import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import React from "react";
import CardContent from "@material-ui/core/CardContent";
import {DoneRounded, AddCircleOutlineRounded} from "@material-ui/icons";
import Box from "@material-ui/core/Box";
import {ButtonBase, Chip} from "@material-ui/core";

export function CardArticulo(props) {
    const {id, detalle, enOrden = true, onClick} = props;
    let {cantidad, scanned} = props;
    cantidad = parseFloat(cantidad) || 0;
    scanned = parseInt(scanned) || 0;

    const allItemsScanned = scanned > 0 && scanned === cantidad;
    // El exceso de cantidad no es un error en el ingreso (se permiten cantidades distintas),
    // pero lo resaltamos para que el operario lo note.
    const differentQuantity = scanned > 0 && scanned !== cantidad;

    const backgroundGreen = 'rgb(0, 150, 136, 0.2)';
    const backgroundAmber = 'rgba(255, 193, 7, 0.2)';

    return (
        <>
            <Card className={'m-0 p-0'} elevation={0} style={{borderRadius: 0}}>
                <ButtonBase style={{width: '100%', display: 'block', textAlign: 'left'}} onClick={onClick}>
                    <CardContent style={{
                        padding: '12px',
                        backgroundColor: allItemsScanned ? backgroundGreen : differentQuantity ? backgroundAmber : 'white'
                    }}
                    >
                        <Box>
                            <Box className={'d-flex justify-content-between align-items-center'}>
                                <Typography color="textPrimary" component={"span"}>
                                    {id}
                                    {!enOrden && (
                                        <Chip
                                            size={"small"}
                                            color={"secondary"}
                                            icon={<AddCircleOutlineRounded/>}
                                            label={"Fuera de OC"}
                                            className={'ml-2'}
                                        />
                                    )}
                                </Typography>
                                {allItemsScanned && (
                                    <DoneRounded fontSize={"small"} color={"primary"} className={'ml-1'}/>
                                )}
                                <Typography
                                    component={"span"}
                                    variant={"body2"}
                                    color={allItemsScanned ? "primary" : "inherit"}
                                    style={{width: '100%'}} align={"right"}
                                >
                                    Escaneados <big>{scanned}</big>
                                    {enOrden && <b> de <big>{cantidad}</big></b>}
                                </Typography>
                            </Box>
                            <Typography variant="body2" color={"textSecondary"} component={"div"}>
                                {detalle}
                            </Typography>
                        </Box>
                    </CardContent>
                </ButtonBase>
            </Card>
        </>
    );
}
